(function () {
    'use strict';

    angular
        .module('smartpublic.config')
        .config(interceptors);

    interceptors.$inject = ['$httpProvider'];

    function interceptors($httpProvider) {
        $httpProvider.interceptors.push(unauthorizedInterceptor);
        $httpProvider.interceptors.push(authenticationTimeoutInterceptor);

        unauthorizedInterceptor.$inject=['$q', '$injector','$log', '$templateCache', 'CACHEBUST_VALUE'];

        function unauthorizedInterceptor($q, $injector,$log, $templateCache, CACHEBUST_VALUE){

            return {
                request: function (config) {
                	
                    if (config.method === "GET" && config.url.indexOf('.html') > -1) {
                        var cachedAlready = $templateCache.get(config.url);
                        if (!cachedAlready) {
                            //$log.debug("not on $templateCache", config.url);
                            var separator = config.url.indexOf('?') === -1 ? '?' : '&';
                            config.url = config.url + separator + 't=' + CACHEBUST_VALUE;
                            //$log.debug("cache busted result", config.url);
                        }
                    }

                    return config || $q.when(config);
                },

                requestError: function (rejection) {

                    return $q.reject(rejection);
                },

                response: function (response) {

                    return response || $q.when(response);
                },

                responseError: function (rejection) {
                    return $q.reject(rejection);
                }
            };

        }


        authenticationTimeoutInterceptor.$inject=['$q', '$window','$log'];
        function authenticationTimeoutInterceptor($q, $window,$log){



            return {

                responseError: function(rejection) {
                    // do something on error
                    $log.debug("HTTP RESPONSE ERROR: ", rejection);

                    // Redirect to index/login page

                    if(rejection.status == -1) {
                        $window.location.href = "";
                    }

                    return $q.reject(rejection);
                }
            };

        }
    }

})();
